import { Send } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { useGridApiContext } from '@mui/x-data-grid';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useProductState } from './state';

export function GridToolbarMassActionButton() {
  const state = useProductState();
  const selectedIds = state.selectedIds.get();
  const history = useHistory();
  const apiRef = useGridApiContext();

  const massActionOnSelected = useCallback(async () => {
    const selectedProducts = selectedIds.map(id => apiRef.current.state.rows.idRowsLookup[id]);
    state.selectedProducts.set(selectedProducts);
    apiRef.current.setSelectionModel([]);
    history.push(ROUTES.massAction);
  }, [apiRef, history, selectedIds, state.selectedProducts]);

  const showSubmitProducts = Boolean(selectedIds.length);
  const buttonText = `change ${selectedIds.length} products`;
  return (
    <Box>
      {showSubmitProducts && (
        <Button onClick={massActionOnSelected} startIcon={<Send />} color='secondary'>
          {buttonText}
        </Button>
      )}
    </Box>
  );
}
